import { render, staticRenderFns } from "./AgentTableTotal.vue?vue&type=template&id=2f3c9a2a&scoped=true"
import script from "./AgentTableTotal.vue?vue&type=script&lang=ts"
export * from "./AgentTableTotal.vue?vue&type=script&lang=ts"
import style0 from "./AgentTableTotal.vue?vue&type=style&index=0&id=2f3c9a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3c9a2a",
  null
  
)

export default component.exports